import { render, staticRenderFns } from "./Slidbar.vue?vue&type=template&id=d2515710&scoped=true"
import script from "./Slidbar.vue?vue&type=script&lang=js"
export * from "./Slidbar.vue?vue&type=script&lang=js"
import style0 from "./Slidbar.vue?vue&type=style&index=0&id=d2515710&prod&lang=less&scoped=true"
import style1 from "./Slidbar.vue?vue&type=style&index=1&id=d2515710&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29728efa34f7641bbb3742d4a0c0d7ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2515710",
  null
  
)

export default component.exports